import $ from "jquery";
import appInfo from './config';

$.ajaxSetup({
    headers : {
        'Authorization' : 'Token ' + appInfo.token + ''
    }
});

async function getGroupMembers(q) {
    const apiEndUrl = '/1tapi/1.5/groups/' + q + '/info'
    let fullUrl = appInfo.server + apiEndUrl;
    return $.ajax({
      type: 'GET',
      url: fullUrl,
      dataType: 'json',
      error: function(err) {
          console.log(err)
      }
    });
  }

  async function getAllGroups() {
    const apiEndUrl = '/1tapi/1.5/groups'
    let fullUrl = appInfo.server + apiEndUrl;
    return $.ajax({
      type: 'GET',
      url: fullUrl,
      dataType: 'json',
    });
  }


  export default {
    getGroupMembers,
    getAllGroups
  }